import {BasicCriteria} from '../../framework/parameters/BasicCriteria';

export class UserCriteria extends BasicCriteria {
mail: string;
nameLike: string;
}

